import { ButtonOptions } from '../button-options'

interface StudentRequestActionButtonProps {
  grantActive: boolean
  denyActive: boolean
  buttonDisabled?: boolean
  grantAction?: () => void
  denyAction?: () => void
}

export const StudentRequestActionButton = ({
  denyActive,
  grantActive,
  buttonDisabled,
  denyAction,
  grantAction
}: StudentRequestActionButtonProps) => {
  const buttons = [
    {
      label: 'Aprovar',
      textColor: 'text-[var(--brand-green)]',
      action: grantAction,
      active: grantActive
    },
    {
      label: 'Reprovar',
      textColor: 'text-destructive',
      action: denyAction,
      active: denyActive
    }
  ]

  return (
    <ButtonOptions disabled={buttonDisabled} label="Ações" items={buttons} />
  )
}
